<template>
  <div class="settings-inner-box">
    <div class="clearfix">
      <p class="settings-heading">Add Ragya to home screen</p>
      <p class="close-icon" @click="close">
        <img src="~@/assets/img/close.svg" alt="close" class="icon" aria-label="close"/>
      </p>
    </div>
    <p class="content-text-instructions">If you're on an iOS device, you can add
     Ragya on your home screen. Just follow the steps below:</p>
    <p class="content-text-instructions"><b>Step 1</b><br/>
     Click on the share icon in your browser</p>
    <div class="img-wrapper"><img src="~@/assets/img/step-1.png"/></div>
    <p class="content-text-instructions"><b>Step 2</b><br/>Select 'Add to Home Screen'</p>
    <div class="img-wrapper"><img src="~@/assets/img/step-2.png"/></div>
    <p class="content-text-instructions"><b>Step 3</b><br/>
      Select Add. You can also give the app a different name, if you may like to.</p>
    <div class="img-wrapper"><img src="~@/assets/img/step-3.png"/></div>
  </div>
</template>

<script>
import Utils from '../mixins/utils';

export default {
  name: 'Instructions',
  mixins: [Utils],
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
